/**
 * A label that shows a sort up or down error
 */

import React from 'react'
import { SORT_DIRECTION } from './types'
import { Th } from 'Components/Table/Th'
import AnimatedArrow from 'Components/Icons/AnimatedArrow'

/**
 * @typedef SortableHeaderProps
 * @property {SORT_DIRECTION} direction The sort direction
 *
 * @param {SortableHeader} props
 */
const SortableHeader = props => {
  const { direction, children, cypress_id, ...otherProps } = props
  return (
    <Th
      {...otherProps}
      cypress_id={cypress_id}
      className="flex-centered align-left"
    >
      {children}
      {(() => {
        switch (direction) {
          case SORT_DIRECTION.NO_SORT:
            return null
          case SORT_DIRECTION.ASCENDING:
            return <AnimatedArrow orientation="up" />
          case SORT_DIRECTION.DECENDING:
            return <AnimatedArrow orientation="down" />
        }
      })()}
    </Th>
  )
}

export default SortableHeader
